import { render, staticRenderFns } from "./ModalSlot.vue?vue&type=template&id=5847ae33&scoped=true&"
import script from "./ModalSlot.vue?vue&type=script&lang=js&"
export * from "./ModalSlot.vue?vue&type=script&lang=js&"
import style0 from "./ModalSlot.vue?vue&type=style&index=0&id=5847ae33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847ae33",
  null
  
)

export default component.exports